const storeNativePendingCredentialProviderInLocalStorage = (nativePendingCredentialProvider) => {
  localStorage.setItem('native_pending_credential_provider', JSON.stringify(nativePendingCredentialProvider))
}

export default storeNativePendingCredentialProviderInLocalStorage
